<wms-dialog-body>
    <p class="message-heading">{{locale.MESSAGE_COMPLETE_APP_IN_FEW_STEPS}}</p>
    <p class="new-message">{{locale.MESSAGE_NEW_TO_WM}}
      <a [href]="wmAcademyLink" target="_blank">{{locale.LABEL_WM_ACADEMY}}</a>
    </p>
    <div class="infographic">
      <div class="step">
        <img src="assets/images/edit-in-wm-info-screen/circle.svg" />
        <img class="align-inside" src="assets/images/edit-in-wm-info-screen/db.svg" />
        <label class="text">{{locale.LABEL_ONBOARD_DATA_SOURCE}}</label>
      </div>
      <div class="arrow">
        <hr>
        <img src="assets/images/edit-in-wm-info-screen/arrows.svg">
      </div>
      <div class="step">
        <img src="assets/images/edit-in-wm-info-screen/circle.svg" />
        <img class="align-inside" src="assets/images/edit-in-wm-info-screen/bind-icon.svg" />
        <label class="text">{{locale.LABEL_BIND_UI}}</label>
      </div>
      <div class="arrow">
        <hr>
        <img src="assets/images/edit-in-wm-info-screen/arrows.svg">
      </div>
      <div class="step">
        <img src="assets/images/edit-in-wm-info-screen/circle.svg" />
        <img class="align-inside" src="assets/images/edit-in-wm-info-screen/publish.svg" />
        <label class="text">{{locale.LABEL_PUBLISH}}</label>
      </div>
    </div>
    <button class="btn-primary" (click)="closeDialog()">{{locale.LABEL_GOT_IT}}</button>
</wms-dialog-body>
